import { Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { analyses, projectActions, message } from "state_management"
import useT from "utils/hooks/useT"

export default function LockUnlockButtons() {
  const { t } = useT("messages")
  const { t: tc } = useT("common")
  const dispatch = useDispatch()
  const IAPmode = useSelector((state) => state.visual.IAPconfig).IAPmode
  return (
    <div className="lockUnlock-btns">
      <Button
        title={
          IAPmode === "analysis"
            ? tc("unlocksAllFutureAnalysisTasks")
            : IAPmode === "project"
            ? tc("unlocksAllFutureProjectActions")
            : tc("unlocks")
        }
        className="lockUnlock-btn"
        variant="light"
        onClick={() => {
          if (IAPmode === "analysis") dispatch(analyses.unlockAll())
          else if (IAPmode === "project") dispatch(projectActions.unlockAll())
          else {
            dispatch(message.warning(t("adhoc.noIapModeSelected")))
          }
        }}
      >
        {tc("unlockItemType", { itemType: IAPmode === "analysis" ? tc("analyses") : IAPmode === "project" ? tc("projects") : "" })}
      </Button>
      <Button
        title={
          IAPmode === "analysis"
            ? tc("locksAllFutureAnalysisTasks")
            : IAPmode === "project"
            ? tc("locksAllFutureProjectActions")
            : tc("locks")
        }
        className="lockUnlock-btn"
        variant="dark"
        onClick={() => {
          if (IAPmode === "analysis") dispatch(analyses.lockAll())
          else if (IAPmode === "project") dispatch(projectActions.lockAll())
          else {
            dispatch(message.warning(t("adhoc.noIapModeSelected")))
          }
        }}
      >
        {tc("lockItemType", { itemType: IAPmode === "analysis" ? tc("analyses") : IAPmode === "project" ? tc("projects") : "" })}
      </Button>
    </div>
  )
}
